import theme from './diEmotionTheme';

export * from './diEmotionTheme';

export default theme;
